export default "__VITE_ASSET__BOcZruIT__"